// DOM проверките, по които глобалният Esc (SharedAccountGate), клавиатурата
// на работните листове и на монитора решават „клавишът мой ли е". Живеят на
// ЕДНО място, за да разпознават отворен слой еднакво — копие би се разминало.

// Фокусът е в поле за писане — там Esc/буквите си са на полето.
export const isEditableTarget = (el: EventTarget | null) =>
  el instanceof HTMLElement &&
  (el.tagName === "INPUT" ||
    el.tagName === "TEXTAREA" ||
    el.tagName === "SELECT" ||
    el.isContentEditable);

// Видима ли е някоя от обвивките. Модалите остават в DOM и след затваряне
// (leave анимация / destroyOnClose), затова видимостта се гледа през computed
// display, не само по наличие.
const isAnyVisible = (selector: string) =>
  [...document.querySelectorAll<HTMLElement>(selector)].some(
    (el) => getComputedStyle(el).display !== "none",
  );

// Отворен antd слой (модал/чекмедже/попъп) — Esc е негов (затваря го), не наш.
export const hasOpenOverlay = () => {
  if (isAnyVisible(".ant-modal-wrap, .ant-image-preview-wrap")) return true;
  return !!document.querySelector(
    ".ant-drawer-open, .ant-popover:not(.ant-popover-hidden), " +
      ".ant-dropdown:not(.ant-dropdown-hidden), .ant-select-open, " +
      ".ant-picker-dropdown:not(.ant-picker-dropdown-hidden)",
  );
};

// Най-горният видим antd модал — последният в DOM (portal-ите се добавят в
// края на body). Esc го затваря само ако тръгне от обвивката му (rc-dialog
// слуша там) — ползва го бутонът „назад" (routes/BackButtonAsEscape.tsx).
// Без `.at(-1)`: вика се на всяко „назад", а старите iPad-и (Safari < 15.4)
// го нямат.
export const topOpenModal = (): HTMLElement | undefined => {
  const visible = [
    ...document.querySelectorAll<HTMLElement>(".ant-modal-wrap"),
  ].filter((el) => getComputedStyle(el).display !== "none");
  return visible[visible.length - 1];
};

// Отворен точно този antd модал (по `wrapClassName`) — напр. въпросът на
// шпикера „Изпълни без добавките?", докато клавишите на монитора чакат.
export const hasOpenModal = (wrapClassName: string) =>
  isAnyVisible(`.ant-modal-wrap.${wrapClassName}`);
